import React, { useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import './cashout-agent-form.scss'
import { makeAgentCashoutTransaction } from '../../../services/transaction-service';
import { toast } from 'react-toastify';
import BeatLoader from "react-spinners/BeatLoader";
import Constant from "../../../Constant";

const orderSchema = Yup.object().shape({
  pin: Yup.string()
    .required('PIN is required')
    .min(5, 'PIN must be exactly 5 characters')
    .max(5, "PIN must be exactly 5 characters")
    .matches(
      /^([a-zA-Z0-9]){0,5}/,
      'PIN should be alphanumeric. No special characters allowed'
    ),
    agentCode: Yup.string()
    .min(9, 'Agent code must have at least 9 digits')
    .matches(
      /^([0-9]{9,})/,
      'Must have only digits'
    )
    .required('Ce champs est obligatoire')
});

const CashoutAgentForm = ({ userId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = (values) => {
    setIsLoading(true);
    console.log(`Submitting the following data ${JSON.stringify(values)}`);
    makeAgentCashoutTransaction(values).then(res => {
      if(res.status_code == 200 || res.status_code == 201) {
        toast(`${res.message}. You can close this page and return to the app`);
        setMessage(`${res.message}. You can close this page and return to the app`);
      }else {
        toast(`Sorry! ${res.message}`);
        setErrorMessage(res.message);
      }
    }).catch(err => {
      toast(`Sorry, ${err.message}`)
      setErrorMessage(err.message);
    }).finally( () => {
      setIsLoading(false);
      setFormSubmitted(true);
    })
  };

  return  (
    <div className="login-form">
      <div className="login-error">{ errorMessage ? errorMessage : ''}</div>
      <div className='login-info'><h2>AFTA WALLET</h2></div>
      { !formSubmitted &&
        <Formik
        initialValues={{
          pin: "",
          agentCode: "",
          id: userId,
        }}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
        validationSchema={orderSchema}
        >
        {({ handleSubmit, values, handleChange, errors, touched }) => (
          <form onSubmit={handleSubmit}>
            
            <div className={`field`}>
              <p>Veuillez remplir le formulaire pour confirmer le retrait.</p>
            </div>
            <div className={`field`}>
              <label htmlFor="agentCode">Code Agent</label>
              <input
                name="agentCode"
                id="agentCode"
                placeholder="Téléphone du compte Agent"
                value={values.agentCode}
                onChange={handleChange} />
              {errors.agentCode && touched.agentCode ? (
                <div className="error">{errors.agentCode}</div>
              ) : null}
            </div>
            <div className={`field`}>
              <label htmlFor="pin">PIN code</label>
              <input
                type='password'
                name="pin"
                id="pin"
                placeholder="Votre code PIN"
                value={values.pin}
                onChange={handleChange}
              />
              {errors.pin && touched.pin ? (
                <div className="error">{errors.pin}</div>
              ) : null}
            </div>
            <button type="submit" disabled={isLoading}>
              {!isLoading && <span>CONFIRMER</span>}
              {/* {isLoading && <span>Sending ...</span>} */}
              <BeatLoader
                color={Constant.spinner_color}
                loading={isLoading}
                cssOverride={{
                  textAlign: 'center',
                  marginTop: '20px'
                }}
              />
              {/* {isLoading && <Loader />} */}
            </button>
          </form>
        )}
        </Formik>
      }
      {
        formSubmitted && 
        <p className='login-info'>
          {message}
        </p>
      }
    </div>
  );
};

export default CashoutAgentForm;
